<h3>{{ header | translate }}</h3>

@if (isLoading) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <mat-form-field appearance="outline" class="search-input">
    <mat-label>{{ 'Search' | translate }}</mat-label>
    <input matInput type="text" [ngModel]="searchText" (ngModelChange)="onSearchInputChange($event)" [autoFocus]="true">
    @if (selectedNode?.Name) {
      <div class="search-level">
        {{ selectedNode.Name }}
      </div>
    }
    <button matSuffix mat-icon-button aria-label="Clear" [disabled]="!searchText" (click)="onSearchInputChange(undefined)">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  @if (selectedNode?.Children) {
    @if (!selectedNode.Children?.length) {
      <span>{{ emptyDataMessage | translate }}</span>
    }
    <div class="breadcrumb-container">
      <button mat-icon-button aria-label="Return to up level button" (click)="onReturnButtonClick()" [disabled]="isRootLevel">
        <mat-icon>keyboard_return</mat-icon>
      </button>
      <div class="custom-breadcrumb">
        @if (selectedNode) {
          <ng-container
            [ngTemplateOutlet]="breadcrumbItem"
            [ngTemplateOutletContext]="{ node: selectedNode }">
          </ng-container>
        }
      </div>
    </div>
    @if (selectedNode?.Children?.length) {
      <div class="container">
        <mat-list role="list">
          <ng-container
            [ngTemplateOutlet]="list"
            [ngTemplateOutletContext]="{ items: filteredItemList$ | async }">
          </ng-container>
        </mat-list>
      </div>
    }
  }
}

<ng-template #list let-items='items'>
  @for (item of items; track trackById($index, item)) {
    <mat-list-item role="listitem" (click)="onNodeItemClick(item)">
      <span
        [matBadge]="item.FilteredChildren?.length"
        [matBadgeHidden]="!item.FilteredChildren?.length"
        matBadgeColor="primary"
        matBadgeOverlap="false"
        matBadgeSize="small"
        >
        <span [innerHTML]="searchText ? (colorize(item.Name) | safeHtml) : item.Name"></span>
      </span>
      @if (item.FilteredChildren?.length) {
        <button matSuffix mat-icon-button class="show-node-childrens-button" (click)="onShowNodeChildrensButtonClick(item)">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      }
    </mat-list-item>
    @if (searchText) {
      <div class="nested-item">
        <ng-container
          [ngTemplateOutlet]="list"
          [ngTemplateOutletContext]="{ items: item.FilteredChildren }">
        </ng-container>
      </div>
    }
  }
</ng-template>

<ng-template #breadcrumbItem let-node='node'>
  @if (!node?.Parent) {
    <mat-icon (click)="onBreadcrumbNodeClick(node)" class="custom-breadcrumb-item root">home</mat-icon>
  }
  @if (node?.Name) {
    <span (click)="onBreadcrumbNodeClick(node)" class="custom-breadcrumb-item">{{ node.Name }}</span>
  }
  @if (node?.Parent) {
    <span class="custom-breadcrumb-separator">/</span>
  }

  @if (node?.Parent) {
    <ng-container
      [ngTemplateOutlet]="breadcrumbItem"
      [ngTemplateOutletContext]="{ node: node.Parent }">
    </ng-container>
  }
</ng-template>